import { Component, EventEmitter, inject, OnInit, Output } from "@angular/core";
import { ScratchCard, SCRATCH_TYPE, SC_CONFIG } from "scratchcard-js";
import { GlobalService } from "src/app/services/global.service";
import { OrwiScratchService } from "./orwi-scratch.service";
import { ScratchStore } from "./state/scratch.store";
import { UserService } from "src/app/services/user/user.service";
import { Coupon } from "src/app/services/dto/orwi-store";
import { CouponService } from "src/app/services/store/coupon.service";
import { ScratchService } from "./state/scratch.service";

@Component({
  selector: "app-orwi-scratch",
  templateUrl: "./orwi-scratch.component.html",
  styleUrls: ["./orwi-scratch.component.scss"],
})
export class OrwiScratchComponent implements OnInit {
  cardImg: string;
  constructor(
    private glb: GlobalService,
    private scratchStore: ScratchStore,
    private orwiScratchService: OrwiScratchService,
    private userService: UserService,
    private scService: ScratchService
  ) {}

  couponService = inject(CouponService)
  scratchService = inject(ScratchService);

  async ngOnInit() {

    await this.couponService.getUserCoupons().then(async (coupons:Coupon[])=>{
      if (coupons.length > 0) {
        await this.scratchService.init(coupons[0]);
      }
    })
    
    var that = this;

    this.cardImg = this.glb.giftCardImage;
    if (!this.cardImg) {
      this.cardImg =
        "assets/images/gamification/gift-card-" +
        this.userService.userLanguage +
        ".png";
    }

    const scInfos = document.querySelector(".sc__infos");
    const sc = new ScratchCard("#js--sc--container", {
      scratchType: SCRATCH_TYPE.BRUSH,
      containerWidth: window.innerWidth < 400 ? window.innerWidth : 400,
      containerHeight: 250,
      brushSrc: "https://masth0.github.io/ScratchCard/images/brush.png",
      imageForwardSrc: this.cardImg,
      imageBackgroundSrc: this.scratchStore.getValue().giftImage,
      htmlBackground: "",
      clearZoneRadius: 0,
      nPoints: 30,
      pointSize: 4,
      enabledPercentUpdate: true,
      percentToFinish: 20,
      callback: function () {
        if (
          that.scratchStore.getValue().name &&
          that.scratchStore.getValue().desc
        ) {
          scInfos.innerHTML = `
            <div>
            <b>
            ${that.scratchStore.getValue().name}
            </b>
            </div>
            <div style="padding:1rem;">
            ${that.scratchStore.getValue().desc}
            </div>
            `;

            that.scService.scratchLoaded.next("");
        }
      },
    } as SC_CONFIG);

    // Init
    sc.init()
      .then(() => {})
      .catch(() => {});
  }

  init() {
    // const background = this.scratchStore.getValue().giftImage;
    // const scContainer = document.getElementById("js--sc--container");
    // const scInfos = document.querySelector(".sc__infos");
    // const sc = new ScratchCard(scContainer, {
    //   scratchType: SCRATCH_TYPE.BRUSH,
    //   containerWidth: 400,
    //   containerHeight: 250,
    //   imageForwardSrc: this.cardImg,
    //   imageBackgroundSrc: "assets/images/beltur/beltur-full-banner.png",
    //   htmlBackground: "",
    //   clearZoneRadius: 0,
    //   nPoints: 30,
    //   pointSize: 4,
    //   callback: function () {
    //     //alert('Now the window will reload !')
    //     //window.location.reload()
    //     //this.iPercent = 100
    //     //scInfos.innerHTML =  '100%';
    //     if (!that.scratchStore.getValue()?.coupon?.id) {
    //       scInfos.innerHTML = `
    //       <div>
    //       <b>
    //       ${that.scratchStore.getValue().name}
    //       </b>
    //       </div>
    //       <div>
    //       ${that.scratchStore.getValue().desc}
    //       </div>
    //       `;
    //       that.cs.getUserCoupons().then((o) => {
    //         that.scService.scratchLoaded.next("");
    //       });
    //     } else {
    //       that.glb.showLoading();
    //       that.cs
    //         .loadCoupon(that.scratchStore.getValue().coupon.id)
    //         .then((o) => {
    //           that.glb.closeLoading();
    //           scInfos.innerHTML = `
    //         <div>
    //         <b>
    //         ${that.scratchStore.getValue().name}
    //         </b>
    //         </div>
    //         <div>
    //         ${that.scratchStore.getValue().desc}
    //         </div>
    //         `;
    //           that.cs.getUserCoupons().then((o) => {
    //             that.scService.scratchLoaded.next("");
    //           });
    //         });
    //     }
    //   },
    // } as SC_CONFIG);
    // // Init
    // sc.init()
    //   .then(() => {
    //     sc.canvas.addEventListener("scratch.move", () => {
    //       //let percent = sc.getPercent().toFixed(0);
    //       //this.iPercent = sc.getPercent()
    //       //scInfos.innerHTML = percent + '%';
    //       //scInfos.innerHTML =  this.scratchStore.getValue().name;
    //     });
    //   })
    //   .catch((error) => {
    //     // image not loaded
    //     //alert(error.message);
    //     //scInfos.innerHTML =  this.scratchStore.getValue().name;
    //   });
  }

  destroy() {
    this.orwiScratchService.destroyComponent();
  }
}
